import styled from 'styled-components';

export const TabsContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`;

export const Tab = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.ms} 0;
  background-color: transparent;
  color: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.text.muted)};
  border: none;
  border-bottom: ${({ $active, theme }) => ($active ? `2px solid ${theme.colors.primary}` : '2px solid transparent')};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
